require('normalize.css/normalize.css');
require('styles/App.scss');

import { hot } from 'react-hot-loader/root';
import React from 'react';
import ImageCard from './ImageCardComponent';
import VerticalImageCard from './VerticalImageCardComponent';
import BackToTop from './BackToTopComponent';
import TabIcon from './TabIconComponent';
import { scroller, Element } from 'react-scroll';
import { t, updateLanguage } from '../util/i18n';
import { Carousel } from 'antd';
import 'antd/dist/antd.css';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    console.log(window.location.search);
    this.state = {
      showBackToTop: false,
      search: window.location.search,
      autoPlay: true,
    };
    this.handleScroll = this.handleScroll.bind(this);
    updateLanguage();
  }

  componentDidMount() {
    console.log(this.props);
    var hash = location.hash;
    if (hash.indexOf('#') == 0) {
      setTimeout(() => {
        console.log('scrolled to ' + hash.substr(1));
        scroller.scrollTo(hash.substr(1), { smooth: true, duration: 400 });
      }, 1000);
    }
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    var top = window.pageYOffset || document.documentElement.scrollTop;
    if (top > 200 && !this.state.showBackToTop)
      this.setState({
        showBackToTop: true,
      });
    if (top < 200 && this.state.showBackToTop)
      this.setState({
        showBackToTop: false,
      });
  }

  pauseSlide() {
    this.setState({ autoPlay: false });
  }

  //   <ImageCard
  //   id="activities-changi-experience-studio"
  //   imagePath='url("../images/hub_spoke.png")'
  //   text1={t('Hub&Spoke')}
  //   location={t('TBD')}
  //   url={t('http://hns.relacsys.com/'+this.state.search)}
  // ></ImageCard>

  // <ImageCard
  //   id="food-chope"
  //   imagePath='url("../images/food_1.png")'
  //   text1={t('Chope!')}
  //   text2={t('Changi Airport’s got you covered, finding a spot to satisfy your cravings is just plane simple!')}
  //   url={t('https://www.changiairport.com/en/dine/chopeatchangi.html')}
  // ></ImageCard>

  //<ImageCard
  //  id="transport-park-and-fly-coupon"
  //  imagePath='url("../images/food_2.png")'
  //  text1={t("Waitrr")}
  //  thirdparty={true}
  //  text2={t(
  //    "Use Waitrr to order takeaway ahead of time to skip the line,  or for dining in to skip waiting for service."
  //  )}
  //  url={t("https://changi.waitrr.com/restaurants")}
  //></ImageCard>

  // <VerticalImageCard
  //   id="recommend-sep-out-play"
  //   imagePath='url("../images/rfy_1.png")'
  //   text1={t('Sept Out & Play')}
  //   text1_2={t('(Indoor Playground)')}
  //   text2={t('T1, T3')}
  //   text2_2={t('Redemptions at T3')}
  //   text3={t('From 4 Sep to 4 Oct')}
  //   url={t(
  //     'https://playpass.changiairport.com/#/septout',
  //   )}
  // ></VerticalImageCard>
  // <VerticalImageCard
  //   id="recommend-ces-fiftyoff-adult-child"
  //   imagePath='url("../images/rfy_2.png")'
  //   text1={t('50% Off Adult Tickets')}
  //   text1_2={t('With Purchase Of')}
  //   text1_3={t('Child Ticket')}
  //   text2={t('Changi Experience Studio')}
  //   text3={t('From 4 Sep to 13 Sep')}
  //   url={t(
  //     'https://www.jewelchangiairport.com/en/attractions/ces.html',
  //   )}
  // ></VerticalImageCard>
  // <VerticalImageCard
  //   id="recommend-canopy-fiftyoff-adult-1or3"
  //   imagePath='url("../images/rfy_3.png")'
  //   text1={t('Enjoy 50% Off Canopy')}
  //   text1_2={t('Park Adult Bundle')}
  //   text1_3={t('Package 1 Or 3')}
  //   text2={t('Canopy Park')}
  //   text3={t('From 4 Sep to 13 Sep')}
  //   url={t(
  //     'https://www.jewelchangiairport.com/en/ticketing.html/#schoolholidaypromo ',
  //   )}
  // ></VerticalImageCard>

  render() {
    /*const carouselSettings = {
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: this.state.autoPlay,
      autoplaySpeed: 5000,
      pauseOnFocus: true,
      pauseOnDotsHover: true,
      onSwipe: this.pauseSlide.bind(this)
    };*/
    return (
      <div className="index">
        <Element className="tab-container" name="top">
          <h1>{t('DISCOVER & BOOK')}</h1>
          <div className="tabs">
            <TabIcon text={t('Amenities')} anchor="amenities"></TabIcon>
            <TabIcon
              text={t('Attractions & Events')}
              anchor="activities"
            ></TabIcon>
            {/* <TabIcon text={t('Food')} anchor="food"></TabIcon> */}
            {/* <TabIcon
              text={t('Safe Travel Journey')}
              anchor="services"
            ></TabIcon> */}
          </div>
        </Element>
        {/* <Element className="jewel-container" name="jewel">
          <h1 className="section-title section-title-primary">
            {t('RECOMMENDED FOR YOU')}
          </h1>
          <Carousel {...carouselSettings}>
            <VerticalImageCard
              id="recommend-ces-fiftyoff-child-adult"
              imagePath='url("../images/rfy_4.png")'
              text1={t('50% Off Child Tickets')}
              text1_2={t('With Purchase Of')}
              text1_3={t('Adult Ticket')}
              text2={t('Changi Experience Studio')}
              text3={t('From 1 Oct to 31 Oct')}
              url={t(
                'https://www.jewelchangiairport.com/en/attractions/ces.html',
              )}
            ></VerticalImageCard>
          </Carousel>
        </Element> */}
        <Element className="image-card-container" name="amenities">
          <h1 className="section-title section-title-primary">
            {t('AMENITIES')}
          </h1>
          <ImageCard
            id="amenities-hub-n-spoke"
            imagePath='url("../images/amenities_1.png")'
            text1={t('HUB & SPOKE')}
            text2={t(
              'Rent bicycle lockers and purchase shower passes at HUB & SPOKE located along the new Changi Airport Connector',
            )}
            url={t('https://hns.relacsys.com/' + this.state.search)}
          ></ImageCard>
        </Element>
        <Element className="image-card-container" name="activities">
          <h1 className="section-title section-title-primary">
            {t('ATTRACTIONS & EVENTS')}
          </h1>
          {/* <ImageCard
            id="activities-septout"
            imagePath='url("../images/septout_activity.png")'
            text1={t('Sept Out & Play (Indoor Playground)')}
            text1_2={t('4 Sep - 4 Oct')}
            location={t('T1, T3')}
            location2={t('Redemptions at T3')}
            url={t('https://playpass.changiairport.com/#/septout')}
          ></ImageCard> */}
          {/* <ImageCard
            id="activities-glampcation"
            imagePath='url("../images/attraction_glampcation.png")'
            text1={t('Glampcation in the Clouds')}
            text2={t('Experience a magical night under the stars and be awed by the majestic view of the Rain Vortex.')}
            url={t('https://widget.globaltix.com/user/auth/R003331C27?product=info&id=31471')}
            disabled={true}
          ></ImageCard>
          <ImageCard
            id="activities-glampcation-shiseido"
            imagePath='url("../images/attraction_glampcation_shiseido.png")'
            text1={t('Glampcation at Shiseido Forest Valley')}
            text2={t('Be one of the first to spend the night at Jewel’s Shiseido Forest Valley this Christmas season!')}
            url={t('https://widget.globaltix.com/user/auth/R003331C27?product=info&id=31534')}
            disabled={true}
          ></ImageCard>
          <ImageCard
            id="activities-familycamp"
            imagePath='url("../images/attraction_familycamp.png")'
            text1={t('A Night at the Airport Family Camp')}
            text2={t('Camp overnight at Changi Experience Studio and enjoy fun-filled activities and behind-the-scenes airport tours!')}
            url={t('https://widget.globaltix.com/user/auth/R003331C27?product=info&id=31470')}
          ></ImageCard>
          <ImageCard
            id="activities-sleepoverplay"
            imagePath='url("../images/attraction_sleepoverplay.png")'
            text1={t('Changi Experience Studio Play + Sleepover')}
            text2={t('Enjoy a magical sleepover in the cosy comfort of the studio amid your favourite games!')}
            url={t('https://widget.globaltix.com/user/auth/R003331C27?product=info&id=31510')}
          ></ImageCard>
          <ImageCard
            id="activities-glampicnic"
            imagePath='url("../images/attraction_glampicnic.png")'
            text1={t('Glampicnic in the Clouds')}
            text2={t('Clink glasses and make memorable moments with your friends or loved ones in an idyllic garden setting.')}
            url={t('https://widget.globaltix.com/user/auth/R003331C27?product=info&id=31472')}
          ></ImageCard>
          <ImageCard
            id="activities-workshops"
            imagePath='url("../images/attraction_workshops.png")'
            text1={t('Workshops & Activities')}
            text2={t("Create your own succulent terrarium, or learn the art of aquascaping, or get up close with Changi's firefighters and vehicles!")}
            url={t('https://www.changiairport.com/en/discover/The-Changi-Festive-Village.html#workshops')}
            buttonText={"MORE INFO"}
          ></ImageCard>
          <ImageCard
            id="activities-jurassic"
            imagePath='url("../images/attraction_jurassic.png")'
            text1={t('Jurassic Mile')}
            text2={t('Be wowed by a 1KM trail of more than 20 life-sized dinosaurs. Exclusive bicycle rentals with dino bundle package available now!')}
            url={t('https://widget.globaltix.com/user/auth/R003331C27?product=info&id=31494')}
          ></ImageCard> */}
          {/* <ImageCard
            id="activities-hershey"
            imagePath='url("../images/hershey.png")'
            text1={t("HERSHEY'S Roller Rink")} 
            text1_2={t('12 Mar to 3 May 2021')}
            location={t('T3, Lvl 2 (Near Row 11)')} 
            url={t('https://playpass.changiairport.com/#/HersheyRollerRink')}
          ></ImageCard> */}
          {/* <ImageCard
            id="activities-jewel-wilderness"
            imagePath='url("../images/jewel_wilderness.png")'
            text1={t(
              'Jewel Wilderness Explorer Learning Journey – Ages 7 to 12',
            )}
            text1_2={t('Till 31 Dec 2021')}
            location={t('Jewel Changi Airport')}
            url={t('https://bit.ly/JWEP21')}
          ></ImageCard> */}
          <ImageCard
            id="activities-changi-experience-studio"
            imagePath='url("../images/ces.png")'
            text1={t('Changi Experience Studio')}
            location={t('Jewel, Lvl 4')}
            url={t(
              'https://www.jewelchangiairport.com/en/attractions/ces.html',
            )}
          ></ImageCard>
          <ImageCard
            id="activities-canopy-park-and-more"
            imagePath='url("../images/canopy.png")'
            text1={t('Canopy Park & More')}
            location={t('Jewel, Lvl 5')}
            url={t('https://www.jewelchangiairport.com/en/ticketing.html')}
          ></ImageCard>
        </Element>
        {/* <Element className="image-card-container" name="food">
          <h1 className="section-title section-title-primary">{t('FOOD')}</h1>
          <ImageCard
            id="food-delivery"
            imagePath='url("../images/food_4.png")'
            text1={t('Food Delivery')}
            text2={t(
              'Use our brand new food delivery platform to order from up to 5 restaurants in a single order!',
            )}
            url={t('https://changi.ezqr.sg')}
          ></ImageCard>
        </Element> */}
        {/* <Element className="services-container" name="services">
          <h1 className="section-title section-title-primary">
            {t('SAFE TRAVEL JOURNEY')}
          </h1>
          <div className="image-card-container">
            <ImageCard
              id="services-test"
              imagePath='url("../images/service_5.png")'
              text1={t('COVID-19 Swab Test')}
              text2={t(
                'Book and pay before you arrive at Changi. ONLY for SafeTravel Pass holders',
              )}
              url={t('https://safetravel.changiairport.com')}
            ></ImageCard>

            <ImageCard
              id="services-covid19-travel"
              imagePath='url("../images/service_7.png")'
              text1={t('Travelling out of Singapore')}
              buttonText="VIEW"
              text2={t(
                "Check your destination's travel advisories and requirements before your departure",
              )}
              url={t(
                'https://www.changiairport.com/en/airport-guide/Covid-19/Travelling-from-Singapore.html',
              )}
            ></ImageCard>

            <ImageCard
              id="services-covid19-info"
              imagePath='url("../images/service_6.png")'
              text1={t('COVID-19 Info Hub')}
              buttonText="VIEW"
              text2={t(
                'Get updated information on travelling through Changi Airport',
              )}
              url={t(
                'https://www.changiairport.com/en/airport-guide/Covid-19.html',
              )}
            ></ImageCard>
          </div>
          <div style={{ position: 'absolute' }}>
            <a href="https://cagapp.page.link/?apn=com.changiairport.cagapp&isi=391730848&ibi=com.changiairport.cagapp&link=https%3A%2F%2Fuat1-playpass.changiairport.com%3Fmode%3Dchangi_playpass">
              <img src="../images/testing-tile.png" height="50" />
            </a>
          </div>
        </Element> */}

        <div className="page-footer">
          <div className="footer-content"></div>
        </div>
        {this.state.showBackToTop && <BackToTop />}
      </div>
    );
  }
}

AppComponent.defaultProps = {};

export default hot(AppComponent);



// WEBPACK FOOTER //
// ./src/components/Main.js